var $1a3060455f092170$exports = {};
const $1a3060455f092170$var$dictionary = {
    "input.number.placeholder": {
        english: "Press play, then enter<br>the number you heard here",
        german: "Dr\xfccke Play, dann gebe<br>die geh\xf6rte Zahl hier ein",
        russian: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043A\u043D\u043E\u043F\u043A\u0443 \u0432\u043E\u0441\u043F\u0440\u043E\u0438\u0437\u0432\u0435\u0434\u0435\u043D\u0438\u044F,<br>\u0430 \u0437\u0430\u0442\u0435\u043C \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u0443\u0441\u043B\u044B\u0448\u0430\u043D\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440",
        romanian: "Ap\u0103sa\u021Bi play, apoi introduce\u021Bi<br>num\u0103rul pe care l-a\u021Bi auzit aici",
        turkish: "Oynat d\xfc\u011Fmesine bas\u0131n, sonra<br>duydu\u011Funuz numaray\u0131 buraya girin",
        spanish: "Presiona reproducir, luego introduce<br>el n\xfamero que escuchaste aqu\xed"
    },
    "setting.range.title": {
        english: "Numbers up to",
        german: "Zahlen bis zu",
        russian: "\u0427\u0438\u0441\u043B\u0430 \u0434\u043E",
        romanian: "Numere p\xe2n\u0103 la",
        turkish: "\u015Eu say\u0131lara kadar",
        spanish: "N\xfameros hasta"
    },
    "setting.voice.title": {
        english: "Spoken Language",
        german: "Gesprochene Sprache",
        russian: "\u0420\u0435\u0447\u0435\u0432\u043E\u0439 \u044F\u0437\u044B\u043A",
        romanian: "Limba vorbit\u0103",
        turkish: "Konu\u015Fulan dil",
        spanish: "Idioma hablado"
    },
    "setting.voice.language.english": {
        english: "English",
        german: "Englisch",
        russian: "\u0410\u043D\u0433\u043B\u0438\u0439\u0441\u043A\u0438\u0439",
        romanian: "Englez\u0103",
        turkish: "\u0130ngilizce",
        spanish: "Ingl\xe9s"
    },
    "setting.voice.language.german": {
        english: "German",
        german: "Deutsch",
        russian: "\u041D\u0435\u043C\u0435\u0446\u043A\u0438\u0439",
        romanian: "German\u0103",
        turkish: "Alman",
        spanish: "Alem\xe1n"
    },
    "setting.voice.language.russian": {
        english: "Russian",
        german: "Russisch",
        russian: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439",
        romanian: "Rus\u0103",
        turkish: "Rus\xe7a",
        spanish: "Ruso"
    },
    "setting.voice.language.romanian": {
        english: "Romanian",
        german: "Rum\xe4nisch",
        russian: "\u0420\u0443\u043C\u044B\u043D\u0441\u043A\u0438\u0439",
        romanian: "Rom\xe2n\u0103",
        turkish: "Romence",
        spanish: "Rumano"
    },
    "setting.voice.language.turkish": {
        english: "Turkish",
        german: "T\xfcrkisch",
        russian: "\u0422\u0443\u0440\u0435\u0446\u043A\u0438\u0439",
        romanian: "Turc\u0103",
        turkish: "T\xfcrk",
        spanish: "Turco"
    },
    "setting.voice.language.spanish": {
        english: "Spanish",
        german: "Spanisch",
        russian: "\u0418\u0441\u043F\u0430\u043D\u0441\u043A\u0438\u0439",
        romanian: "Spaniol\u0103",
        turkish: "\u0130spanyol",
        spanish: "Espa\xf1ol"
    },
    "stats.title.en-US": {
        english: "Stats for English numbers",
        german: "Statistiken f\xfcr englische Zahlen",
        russian: "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430 \u043F\u043E \u0430\u043D\u0433\u043B\u0438\u0439\u0441\u043A\u0438\u043C \u043D\u043E\u043C\u0435\u0440\u0430\u043C",
        romanian: "Statistici pentru numere englez\u0103",
        turkish: "\u0130ngilizce numaralar i\xe7in istatistikler",
        spanish: "Estad\xedsticas para n\xfameros en ingl\xe9s"
    },
    "stats.title.de-DE": {
        english: "Stats for German numbers",
        german: "Statistiken f\xfcr deutsche Zahlen",
        russian: "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430 \u043F\u043E \u043D\u0435\u043C\u0435\u0446\u043A\u0438\u043C \u043D\u043E\u043C\u0435\u0440\u0430\u043C",
        romanian: "Statistici pentru numere germane",
        turkish: "Alman numaralar i\xe7in istatistikler",
        spanish: "Estad\xedsticas para n\xfameros en alem\xe1n"
    },
    "stats.title.ru-RU": {
        english: "Stats for Russian numbers",
        german: "Statistiken f\xfcr russische Zahlen",
        russian: "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430 \u043F\u043E \u0440\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u0438\u043C \u043D\u043E\u043C\u0435\u0440\u0430\u043C",
        romanian: "Statistici pentru numere ruse\u0219ti",
        turkish: "Rus numaralar i\xe7in istatistikler",
        spanish: "Estad\xedsticas para n\xfameros en ruso"
    },
    "stats.title.ro-RO": {
        english: "Stats for Romanian numbers",
        german: "Statistiken f\xfcr rum\xe4nische Zahlen",
        russian: "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430 \u043F\u043E \u0440\u0443\u043C\u044B\u043D\u0441\u043A\u0438\u043C \u043D\u043E\u043C\u0435\u0440\u0430\u043C",
        romanian: "Statistici pentru numere rom\xe2ni",
        turkish: "Romence numaralar i\xe7in istatistikler",
        spanish: "Estad\xedsticas para n\xfameros en rumano"
    },
    "stats.title.tr-TR": {
        english: "Stats for Turkish numbers",
        german: "Statistiken f\xfcr t\xfcrkische Zahlen",
        russian: "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430 \u043F\u043E \u0442\u0443\u0440\u0435\u0446\u043A\u0438\u043C \u043D\u043E\u043C\u0435\u0440\u0430\u043C",
        romanian: "Statistici pentru numere turce\u0219ti",
        turkish: "T\xfcrk numaralar i\xe7in istatistikler",
        spanish: "Estad\xedsticas para n\xfameros en turco"
    },
    "stats.title.es-ES": {
        english: "Stats for Spanish numbers",
        german: "Statistiken f\xfcr spanische Zahlen",
        russian: "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430 \u043F\u043E \u0438\u0441\u043F\u0430\u043D\u0441\u043A\u0438\u043C \u043D\u043E\u043C\u0435\u0440\u0430\u043C",
        romanian: "Statistici pentru numere spaniole",
        turkish: "\u0130spanyol numaralar i\xe7in istatistikler",
        spanish: "Estad\xedsticas para n\xfameros en espa\xf1ol"
    },
    "stats.solved.total": {
        english: "Total solved :",
        german: "Insgesamt gel\xf6st :",
        russian: "\u0412\u0441\u0435\u0433\u043E \u0440\u0435\u0448\u0435\u043D\u043E :",
        romanian: "Total rezolvat :",
        turkish: "Toplam \xe7\xf6z\xfclen :",
        spanish: "Total resuelto :"
    },
    "stats.solved.10": {
        english: "up to 10 :",
        german: "bis zu 10 :",
        russian: "\u0434\u043E 10 :",
        romanian: "p\xe2n\u0103 la 10 :",
        turkish: "10'a kadar :",
        spanish: "hasta 10 :"
    },
    "stats.solved.100": {
        english: "up to 100 :",
        german: "bis zu 100 :",
        russian: "\u0434\u043E 100 :",
        romanian: "p\xe2n\u0103 la 100 :",
        turkish: "100'e kadar :",
        spanish: "hasta 100 :"
    },
    "stats.solved.1000": {
        english: "up to 1000 :",
        german: "bis zu 1000 :",
        russian: "\u0434\u043E 1000 :",
        romanian: "p\xe2n\u0103 la 1000 :",
        turkish: "1000'e kadar :",
        spanish: "hasta 1000 :"
    },
    "stats.solved.1000000": {
        english: "up to 1000000 :",
        german: "bis zu 100000 :",
        russian: "\u0434\u043E 100000 :",
        romanian: "p\xe2n\u0103 la 100000 :",
        turkish: "100000'e kadar :",
        spanish: "hasta 1000000 :"
    },
    "stats.solved.streak": {
        english: "Longest winning streak :",
        german: "L\xe4ngste Gewinnstr\xe4hne :",
        russian: "\u0421\u0430\u043C\u0430\u044F \u0434\u043B\u0438\u043D\u043D\u0430\u044F \u0432\u044B\u0438\u0433\u0440\u044B\u0448\u043D\u0430\u044F \u0441\u0435\u0440\u0438\u044F :",
        romanian: "Cea mai lung\u0103 serie de c\xe2\u0219tiguri :",
        turkish: "En uzun kazanma serisi :",
        spanish: "Racha ganadora m\xe1s larga :"
    },
    "stats.solved.highest": {
        english: "Highest number :",
        german: "H\xf6chste Zahl :",
        russian: "\u041D\u0430\u0438\u0431\u043E\u043B\u044C\u0448\u0435\u0435 \u0447\u0438\u0441\u043B\u043E :",
        romanian: "Cel mai mare num\u0103r :",
        turkish: "En y\xfcksek say\u0131 :",
        spanish: "N\xfamero m\xe1s alto :"
    },
    "stats.solved.quickest": {
        english: "Quickest solve :",
        german: "Schnellste L\xf6sung :",
        russian: "\u0421\u0430\u043C\u043E\u0435 \u0431\u044B\u0441\u0442\u0440\u043E\u0435 \u0440\u0435\u0448\u0435\u043D\u0438\u0435 :",
        romanian: "Cea mai rapid\u0103 rezolvare :",
        turkish: "En h\u0131zl\u0131 \xe7\xf6z\xfcm :",
        spanish: "Soluci\xf3n m\xe1s r\xe1pida :"
    }
};
function $1a3060455f092170$var$determineLanguage() {
    let language;
    let languageCode;
    let location = window.location.href.split("#");
    if (location.length > 1) languageCode = location[1];
    else languageCode = navigator.language.split("-")[0];
    switch(languageCode){
        case "de":
            language = "german";
            break;
        case "ru":
            language = "russian";
            break;
        case "ro":
            language = "romanian";
            break;
        case "tk":
            language = "turkish";
            break;
        case "es":
            language = "spanish";
            break;
        default:
            language = "english";
            break;
    }
    return language;
}
function $1a3060455f092170$var$propagateLanguage() {
    let language = $1a3060455f092170$var$determineLanguage();
    let elements = document.querySelectorAll('[data-dict]');
    elements.forEach((element)=>{
        let key = element.getAttribute("data-dict");
        element.innerHTML = $1a3060455f092170$var$dictionary[key][language];
    });
}
window.addEventListener('hashchange', function() {
    $1a3060455f092170$var$propagateLanguage();
});
const $1a3060455f092170$var$observer = new MutationObserver(()=>{
    $1a3060455f092170$var$propagateLanguage();
});
document.querySelectorAll('[data-dict]').forEach((element)=>{
    $1a3060455f092170$var$observer.observe(element, {
        attributes: true
    });
});
$1a3060455f092170$var$propagateLanguage();


//# sourceMappingURL=app.6eebd6e7.js.map
